const DEFAULT_QUIZ_RESULTS_TEXTS = {
  addons: {
    subtitleOtpOn: "Boost your results with add-ons",
    subtitleDefault: "Take 15% off any add-ons today!",
    freeLabel: "FREE",
    trialDiscountSuffix: "% OFF",
  },
  blurb: {
    loadingText: "Analyzing your skin profile...",
    title: "Why this regimen is right for you",
    bottomNote: "Summary Generated by AI. Verified by humans.",
  },
  refillToggle: {
    otpWithDiscount: "% off unlocked!",
    autoWithDiscount: "% off your first trial box  |  3-month refills just $99!",
    otpNoDiscount: "Choose auto-refills and access exclusive perks",
  },
  regimen: {
    priceSuffix: "TODAY",
    activeIngredientLabel: "Active Ingredient",
    routineSteps: [
      {
        image:
          "https://cdn.shopify.com/s/files/1/0027/3527/6076/files/sun_icon_2a8af187-dad3-4880-9734-c0a6a69b9648.svg?v=1744896711",
        text: "Morning: Face Wash • Morning Cream",
        imageAlt: "Sun",
      },
      {
        image:
          "https://cdn.shopify.com/s/files/1/0027/3527/6076/files/moon_icon_f5019fe2-4261-478f-adc0-c8c76b1b7999.svg?v=1744896711",
        text: "Night: Face Wash • Night Cream",
        imageAlt: "Moon",
      },
    ],
    affirmations: [
      {
        image:
          "https://cdn.shopify.com/s/files/1/0027/3527/6076/files/vegan_icon_2c797a7e-f579-490e-b89a-c8b3a9fc57af.svg?v=1744896711",
        text: "VEGAN",
      },
      {
        image:
          "https://cdn.shopify.com/s/files/1/0027/3527/6076/files/cruelty_free_icon_f0df00a5-8ab8-4f93-9015-bd607c0b7975.svg?v=1744896711",
        text: "CRUELTY FREE",
      },
      {
        image:
          "https://cdn.shopify.com/s/files/1/0027/3527/6076/files/derm_tested_icon_8acd5a04-38b4-4738-b719-9305c8b6a353.svg?v=1744896711",
        text: "DERM TESTED",
      },
    ],
    constituents: {
      "CL01-S": {
        card: {
          title: "01 - Cleanse & Refresh",
          label: "Everyday Face Wash - Sensitive Formula",
          images: {
            mobile:
              "https://cdn.shopify.com/s/files/1/0027/3527/6076/files/FW_Sensitive_mobile.png?v=1730132300",
          },
          bullets: [
            "Gently Cleans and Unclogs Pores",
            "Controls Excess Oil",
            "Designed for Sensitive Skin",
          ],
          active_ingredients: [],
        },
      },
      "CL02-SA": {
        card: {
          title: "01 - Cleanse & Refresh",
          label: "Everyday Face Wash - Unscented",
          images: {
            mobile:
              "https://cdn.shopify.com/s/files/1/0027/3527/6076/files/FW_Unscented_mobile.png?v=1730132300",
          },
          bullets: [
            "Deep Cleans Pores",
            "Controls Excess Oil",
            "Gentle Exfoliation",
          ],
          active_ingredients: ["2% SAlicylic Acid"],
        },
      },
      "CL03-N": {
        card: {
          title: "01 - Cleanse & Refresh",
          label: "Everyday Face Wash - Bergamot + Juniper",
          images: {
            mobile:
              "https://cdn.shopify.com/s/files/1/0027/3527/6076/files/FW_Bergamot_mobile.png?v=1730132300",
          },
          bullets: [
            "Deep Cleans Pores",
            "Controls Excess Oil",
            "Gentle Exfoliation",
          ],
          active_ingredients: ["2% SAlicylic Acid"],
        },
      },
      "AM07-SNL": {
        card: {
          title: "02 - Protect & Moisturize",
          label: "Moisturizing Morning Cream SPF 15",
          images: {
            mobile:
              "https://cdn.shopify.com/s/files/1/0027/3527/6076/files/Am_Cream_SPF15_mobile.png?v=1730132300",
          },
          bullets: [
            "Deep + Lasting Hydration",
            "Controls Excess Oil + Shine",
            "Lightweight Daily SPF",
          ],
          active_ingredients: [
            "3% Niacinamide",
            "2% Hyaluronic Acid",
            "1% Argan Oil",
          ],
        },
      },
      "AM08-R": {
        card: {
          title: "02 - Protect & Moisturize",
          label: "Tone Control Morning Cream SPF 15",
          images: {
            mobile:
              "https://cdn.shopify.com/s/files/1/0027/3527/6076/files/Am_Cream_Tone_Control_SPF15_mobile.png?v=1730132300",
          },
          bullets: [
            "Brightens Tone",
            "Controls Excess Oil + Shine",
            "Lightweight Daily SPF",
          ],
          active_ingredients: [
            "5% Azelaic Acid",
            "2% Hyaluronic Acid",
            "1% Argan Oil",
          ],
        },
      },
      "PM01-S": {
        card: {
          title: "03 - Treat & Recover",
          label: "Night Cream  - 0.1% Retinol Formula",
          images: {
            mobile:
              "https://cdn.shopify.com/s/files/1/0027/3527/6076/files/PM_Cream_1_mobile.png?v=1730132300",
          },
          bullets: [
            "Minimizes Visible Signs of Aging",
            "Controls Excess Oil",
            "Ideal for Sensitive Skin",
          ],
          active_ingredients: [".1% Retinol", "3% Niacinamide", "2% Hyaluronic Acid"],
        },
      },
      "PM02-N": {
        card: {
          title: "03 - Treat & Recover",
          label: "Night Cream  - 0.2% Retinol Formula",
          images: {
            mobile:
              "https://cdn.shopify.com/s/files/1/0027/3527/6076/files/PM_Cream_2_mobile.png?v=1730132300",
          },
          bullets: [
            "Minimizes Visible Signs of Aging",
            "Controls Excess Oil",
            "Improves Tone + Texture",
          ],
          active_ingredients: [".2% Retinol", "3% Niacinamide", "2% Hyaluronic Acid"],
        },
      },
    },
  },
  concerns: {
    icons: {
      Acne:
        "https://cdn.shopify.com/s/files/1/0027/3527/6076/files/acne_icon_a2e922eb-b133-4190-8402-a0d0ac10ebf5.svg?v=1745931461",
      "Redness & Inflammation":
        "https://cdn.shopify.com/s/files/1/0027/3527/6076/files/redness_icon_daec6150-e8e1-4658-8f80-74b2665b48c4.svg?v=1745931461",
      "Under-Eye Puffiness":
        "https://cdn.shopify.com/s/files/1/0027/3527/6076/files/undereye_icon_4c20c8a3-a0eb-4abb-ad30-84bd1e3a38fa.svg?v=1745932035",
      "Dark Spots":
        "https://cdn.shopify.com/s/files/1/0027/3527/6076/files/dark_spots_icon_8c918e98-5eb5-4d29-98c7-9bf93cab80ec.svg?v=1745931461",
      "Aging Signs":
        "https://cdn.shopify.com/s/files/1/0027/3527/6076/files/aging_icon_2267ee27-282c-4952-a8fe-7686fd8244a8.svg?v=1745931461",
      "Uneven Skin Tone":
        "https://cdn.shopify.com/s/files/1/0027/3527/6076/files/uneven_skin_icon_296dea02-4ff5-40a1-8435-c2f26b41691f.svg?v=1745931461",
      "Dry Skin":
        "https://cdn.shopify.com/s/files/1/0027/3527/6076/files/dry_skin_icon_3ba9d059-6af2-4d50-8d5a-6cda150a4f92.svg?v=1745931461",
      "Oily Skin":
        "https://cdn.shopify.com/s/files/1/0027/3527/6076/files/oily_skin_icon_1b2f7ce9-094d-4a4f-8e73-51cf45b20ad5.svg?v=1745931461",
      "General Skin Health":
        "https://cdn.shopify.com/s/files/1/0027/3527/6076/files/skin_health_icon_6868b873-2341-4e79-9aac-16d9b5f757f1.svg?v=1745931461",
    },
    iconAltSuffix: " Icon",
  },
  stickyBar: {
    frequencyOneTime: "one time purchase",
    frequencyRefill: "3 months",
    trialType: "skin",
    setType: "trial",
    cartFetchError: "Failed to fetch cart",
    cartUpdateError: "Failed to update cart",
    cartAddError: "Failed to add items to cart",
  },
  tracking: {
    regimenDefaultName: "30D Trial Set",
    regimenNameTemplatePrefix: "Regimen #",
    regimenNameTemplateSuffix: ": 30D Trial Set",
    classicSet: "Classic Set",
    addonVariant: "add-on",
    addonCoupon: "Trial Add-on Discount",
    onlineStore: "Online Store",
    geologie: "Geologie",
    skincare: "Skincare",
    sampleSetCategory: "30 Day Sample Set",
    classicCategory: "Classic",
    trialAddonCategory: "Trial Add-on",
    itemListId: "octane results",
    recommendedSetListName: "recommended set",
    addonProductsListName: "add-on products",
    productsAddedToCartListName: "products added to cart",
    unknown: "Unknown",
    currency: "USD",
  },
};

function isPlainObject(value) {
  return Boolean(value) && typeof value === "object" && !Array.isArray(value);
}

function mergeDeep(baseValue, overrideValue) {
  if (!isPlainObject(baseValue) || !isPlainObject(overrideValue)) {
    return overrideValue === undefined ? baseValue : overrideValue;
  }

  const merged = { ...baseValue };
  Object.keys(overrideValue).forEach((key) => {
    merged[key] = mergeDeep(baseValue[key], overrideValue[key]);
  });
  return merged;
}

function ensureQuizResultsTexts() {
  const existing = /** @type {any} */ (window).g_quiz_results_texts;
  const merged = mergeDeep(DEFAULT_QUIZ_RESULTS_TEXTS, existing || {});
  /** @type {any} */ (window).g_quiz_results_texts = merged;
  return merged;
}

export function getQuizResultsTexts() {
  return ensureQuizResultsTexts();
}

ensureQuizResultsTexts();
